import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ToastMessageOptions } from '@openng/optimus-ui/api';

@Injectable({
  providedIn: 'root',
})
export class ToastBarService {
  private toastMessageSource = new Subject<ToastMessageOptions>();

  // Expose an observable so components can subscribe to new messages
  toastMessage$: Observable<ToastMessageOptions> = this.toastMessageSource.asObservable();

  constructor() {}

  showToast(message: ToastMessageOptions) {
    // Publish the new message to whoever is listening
    this.toastMessageSource.next(message);
  }

  showToastSuccess(detail: string) {
    // Publish the new message to whoever is listening

    const message = {
      severity: 'success',
      summary: 'Success',
      detail: detail,
    };
    this.toastMessageSource.next(message);
  }

  showToastError(detail: string) {
    // Publish the new message to whoever is listening

    const message = {
      severity: 'error',
      summary: 'Error',
      detail: detail,
    };
    this.toastMessageSource.next(message);
  }
}
